import  Dexie  from 'dexie';
/**
 * Preapres the Database and defines the schema.
 * It's a key/value schema to storing strings which are usually JSON strings
 * 
 */
export class AppDatabase extends Dexie { 
    pairs: Dexie.Table<KeyValuePair, string>;
    constructor() {
        super('able_db');
        this.version(1).stores({
            pairs: 'key,value'
        });
    }
}
/**
 * Defines database item type
 */
export interface KeyValuePair {
    key: string;
    value: string | undefined;
}


// WEBPACK FOOTER //
// ./src/repository/AppDatabase.ts